import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_USER_USD_BANK_DETAILS } from "../../../config/api";
import { showErrorModal } from "../../reducers/messageSlice";
import { getUserBanks } from "./getUserBanks";
import mixpanel from "mixpanel-browser";

export const bankUSDUserActions = createAsyncThunk(
  "banks/bankUSDUserActions",
  async ({ data, cb, failed }, { dispatch, getState }) => {
    const { profile, user } = getState().onboarding;
    const { userBanks } = getState().bank;
    try {
      const response = await Client({
        method: "POST",
        path: API_USER_USD_BANK_DETAILS,
        data: data,
      });

      dispatch(getUserBanks());
      cb();
      mixpanel.track("WEB-Linked USD Bank Account", {
        type: "Banks",
      });
      if (user?.hasSetPin && profile?.nok_email && userBanks?.length < 1) {
        mixpanel.track("WEB-Onboarded", {
          type: "Onboarding",
        });
      }
      // toast.success("Bank account was successfully added.");
      return response;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      mixpanel.track("WEB-Link USD Bank Account Failed", {
        type: "Banks",
        // subtype: "Link Bank Account",
        message: msg,
      });
      dispatch(showErrorModal(msg));
    }
  }
);
